import { useState } from 'react'
import Button from 'components/global/Button'
import PolicyView from './PolicyView'
import CodeView from '../../global/CodeView'
import ListGroup from '../../global/ListGroup'

export default function CompletedLink({ policies, onStartOver }) {
  // Local state
  const [codeViewActive, setCodeViewActive] = useState(false)
  const [activePolicy, setActivePolicy] = useState(policies[0])

  // Render nothing if we don't have a policy
  if (!activePolicy) return false

  const getFirstLine = (policy) => {
    const primaryPerson = (policy.policyholders.filter(
      (person) => person.is_primary
    ) || activePolicy.policyholders)[0]

    return policy.policyholders.length > 1
      ? `${primaryPerson.name.full} + ${policy.policyholders.length - 1} ${
          policy.policyholders.length - 1 > 1 ? 'others' : 'other'
        }`
      : primaryPerson.name.full
  }

  const getSecondLine = (policy) =>
      (policy.line == 'personal_auto' || policy.line == 'motorcycle')
      ? `${policy.vehicles[0].year} ${policy.vehicles[0].make} ${policy.vehicles[0].model}`
      : `${policy.locations[0].address.line1} ${policy.locations[0].address.line2}`

  const getThirdLine = (policy) =>
      (policy.line == 'personal_auto' || policy.line == 'motorcycle')
      ? `(${policy.vehicles[0].vin})`
      : `${policy.locations[0].address.city}, ${policy.locations[0].address.state} ${policy.locations[0].address.postal_code}`

  const mapItems = (policies) =>
    policies.map((policy) => ({
      title: `Policy# ${policy.masked_number}`,
      firstLine: getFirstLine(policy),
      secondLine: getSecondLine(policy),
      thirdLine: getThirdLine(policy),
    }))

  // Render policy options
  return (
    <div className="mx-auto w-full px-4 md:px-0">
      {/* Intro */}
      <div className="mx-auto mb-6 flex max-w-2xl flex-col items-center justify-center rounded-lg bg-purple p-6">
        {/* Text */}
        <div className="mb-6 text-center">
          <h2 className="text-4xl font-bold text-white">
            {policies.length > 1 ? 'Policies Linked' : 'Policy Linked'}
          </h2>
          <p className="mt-4 text-xl text-purple-100">
            View the policy data below to see what data you can access.
          </p>
        </div>

        <div className="flex flex-col items-center space-y-2">
          {/* Selector */}
          <div className="flex items-center space-x-2 rounded-lg bg-purple-900 p-2">
            <div>
              <Button
                color={codeViewActive ? 'clear' : 'white'}
                onClick={() => setCodeViewActive(false)}
              >
                Pretty view
              </Button>
            </div>
            <div>
              <Button
                color={codeViewActive ? 'white' : 'clear'}
                onClick={() => setCodeViewActive(true)}
              >
                Data view
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Output */}
      <div
        className={`mx-auto flex flex-col gap-4 md:flex-row ${
          policies.length > 1 ? 'max-w-5xl' : 'max-w-2xl'
        }`}
      >
        {policies.length > 1 && (
          <ListGroup
            items={policies}
            mappedItems={mapItems(policies)}
            activeItem={activePolicy}
            setActiveItem={setActivePolicy}
          />
        )}

        <div className="flex-1">
          {codeViewActive ? (
            <CodeView json={activePolicy} />
          ) : (
            <PolicyView policy={activePolicy} />
          )}
        </div>
      </div>

      {/* Start over */}
      <div className="mt-12 flex justify-center">
        <Button color="white" onClick={onStartOver}>
          Start over
        </Button>
      </div>
    </div>
  )
}
